package org.hs_soft.runmynesto.pages.home.sub_page.product.mvi

import androidx.compose.runtime.MutableState
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.withContext
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.errorMessage
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError
import org.hs_soft.runmynesto.domain.model.home.options.LanguageEnum
import org.hs_soft.runmynesto.domain.model.home.product.product_item_model.Img
import org.hs_soft.runmynesto.domain.model.home.product.product_item_model.Properties
import org.hs_soft.runmynesto.domain.model.home.product.products_list_model.ProductItem
import org.hs_soft.runmynesto.domain.model.home.product.ProductInfoHeaderEnum
import org.hs_soft.runmynesto.domain.model.home.product.product_item_model.SpecialPriceItem
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.ingeredient_list.Ingredients
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.AppConstantsEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.update_product.UpdateProduct
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.kitchen_info.ProductAdditions
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.selection.FixProductData
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.selection.ProductSetData
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.selection.ProductSetRequest
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets.FixProduct
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets.SetModel
import org.hs_soft.runmynesto.domain.model.home.template.GridItemsFilterEnum
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.Children
import org.hs_soft.runmynesto.domain.requestHandler
import org.hs_soft.runmynesto.domain.usecase.home.GetCompanyProfileIdUseCase
import org.hs_soft.runmynesto.domain.usecase.home.GetSavedCheckOutUseCase
import org.hs_soft.runmynesto.domain.usecase.media_center.tabs.media.LoadAppConstantsUseCase
import org.hs_soft.runmynesto.domain.usecase.product.AddProductUseCase
import org.hs_soft.runmynesto.domain.usecase.product.GetImgUrlUseCase
import org.hs_soft.runmynesto.domain.usecase.product.ProductCategoriesUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_allergens.CheckedIngredientsUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_allergens.CreateProductIngredientUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_allergens.UpdateAllergenUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_checkout.UpdateProductCheckoutUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_click_collect.UpdateProductPropertiesUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_price.CreateSpecialPriceUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.GetSingleProductUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.IngredientListUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.ProductSaleGroupUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.UpdateProductCashBidImageUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.UpdateProductPriceUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.UpdateProductUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.cache.AddProductCategoryToDBUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.cache.GetCachedProductCategoriesUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.cache.SaveCachedProductCategoriesUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_restaurant.CreateProductAdditionUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_restaurant.DeleteProductAdditionUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_restaurant.KitchenInfoUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_restaurant.PrinterLocationNamesUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_restaurant.ProductRestaurantUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_restaurant.UpdateProductAdditionUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_restaurant.UpdateProductRestaurantUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_price.GetSpecialPriceUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_price.UpdateSpecialPriceUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_selection.UpdateProductSetsListUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_selection.GetProductSetUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_selection.UpdateProductSetUseCase
import org.hs_soft.runmynesto.domain.usecase.template.GetTemplateCategoriesUseCase
import org.hs_soft.runmynesto.domain.usecase.template.tabs.tab_general.GetDishPictureUseCase
import org.hs_soft.runmynesto.domain.usecase.template.tabs.tab_options.GetPriceLevelsUseCase
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.IdUtils 
import org.hs_soft.runmynesto.domain.util.helper.BaseViewModel


class ProductViewModel(
    private val requestManager: RequestManager,
    private val getDishPictureUseCase: GetDishPictureUseCase,
    private val checkedIngredientsUseCase: CheckedIngredientsUseCase,
    private val updateAllergenUseCase: UpdateAllergenUseCase,
    private val updateProductCheckoutUseCase: UpdateProductCheckoutUseCase,
    private val updateProductPropertiesUseCase: UpdateProductPropertiesUseCase,
    private val ingredientListUseCase: IngredientListUseCase,
    private val updateProductCashBidImageUseCase: UpdateProductCashBidImageUseCase,
    private val updateProductUseCase: UpdateProductUseCase,
    private val productSaleGroupUseCase: ProductSaleGroupUseCase,
    private val singleProductUseCase: GetSingleProductUseCase,
    private val kitchenInfoUseCase: KitchenInfoUseCase,
    private val productRestaurantUseCase: ProductRestaurantUseCase,
    private val printerLocationNamesUseCase: PrinterLocationNamesUseCase,
    private val updateProductRestaurantUseCase: UpdateProductRestaurantUseCase,
    private val addProductUseCase: AddProductUseCase,
    private val productCategoriesUseCase: ProductCategoriesUseCase,
    private val imgUrlUseCase: GetImgUrlUseCase,
    private val updateProductPriceUseCase: UpdateProductPriceUseCase,
    private val getCompanyProfileIdUseCase: GetCompanyProfileIdUseCase,
    private val addProductCategoryToDBUseCase: AddProductCategoryToDBUseCase,
    private val getCachedProductCategoriesUseCase: GetCachedProductCategoriesUseCase,
    private val saveCachedProductCategoriesUseCase: SaveCachedProductCategoriesUseCase,
    private val createProductAdditionUseCase: CreateProductAdditionUseCase,
    private val updateProductAdditionUseCase: UpdateProductAdditionUseCase,
    private val getSavedCheckOutUseCase: GetSavedCheckOutUseCase,
    private val getTemplateCategoriesUseCase:GetTemplateCategoriesUseCase,
    private val loadAppConstantsUseCase: LoadAppConstantsUseCase,
    private val priceLevelsUseCase: GetPriceLevelsUseCase,
    private val createProductIngredientUseCase: CreateProductIngredientUseCase,
    private val deleteProductAdditionUseCase:DeleteProductAdditionUseCase,
    private val getSpecialPriceUseCase: GetSpecialPriceUseCase,
    private val updateSpecialPriceUseCase: UpdateSpecialPriceUseCase,
    private val createSpecialPriceUseCase: CreateSpecialPriceUseCase,
    private val updateProductSetUseCase: UpdateProductSetUseCase,
    private val getProductSetUseCase: GetProductSetUseCase,
    private val updateProductSetsListUseCase: UpdateProductSetsListUseCase,
):BaseViewModel()
{

    private val _state = MutableStateFlow(ProductState())
    val state: StateFlow<ProductState> = _state
    private var tempCheckoutList: List<Children>? = listOf()
    private var tempIngredients: List<Ingredients>? = listOf()
    private var tempKitchenInfo:List<ProductAdditions?>? = listOf()
    private var tempPrices:List<SpecialPriceItem> = listOf()
    private var temptProductSets:List<SetModel> = listOf()
    private var tempFixedProducts:List<FixProduct?> = listOf()

    override fun clear() {
        requestManager.cancelAll()
    }

    fun onEvent(event: ProductEvent)
    {
        when (event) {

            is ProductEvent.UpdateSelectedProductSet->{
                updateProductSetModel(
                    id=state.value.selectedProduct?.id?:"",
                    setModel=event.setModel
                )
            }

            is ProductEvent.SetDeleteFixedProductDialogStatus->{
                _state.value=_state.value.copy(
                    showDeleteFixedProductDialog = event.status
                )
            }

            is ProductEvent.OnFixedProductItemClick->{
                onFixedProductItemClick(
                    code=event.code
                )
            }

            is ProductEvent.OnSearchInFixedProducts->{
                onSearchInFixedProducts(event.searchValue)
            }

            is ProductEvent.SetAddProductFixDialogStatus->{
                _state.value=_state.value.copy(
                    showAddProductFixDialog = event.status
                )
            }
            is ProductEvent.SetEditProductFixDialogStatus->{
                _state.value=_state.value.copy(
                    showEditProductFixDialog = event.status
                )
            }

            is ProductEvent.SetCreateNewProductSetDialogStatus->{
                _state.value=_state.value.copy(
                    showCreateNewProductSetDialog = event.status
                )
            }

            is ProductEvent.UpdateProductSets->{
                updateProductSets(
                    id=state.value.selectedProduct?.id?:"",
                    title=event.title,
                    value=event.value,
                )
            }
            is ProductEvent.AddProductSets->{
                addProductSets(
                    id=state.value.selectedProduct?.id?:"",
                    categoryId=event.categoryId,
                    sets=state.value.productSets?.sets,
                )
            }

            is ProductEvent.AddFixedProductSet->{
                addFixedProductSets(
                    id=state.value.selectedProduct?.id?:"",
                    sets=state.value.productSets?.sets,
                    categoryId=state.value.selectedProductSet?.category?.id?:"",
                    productId=event.productId,
                    price=event.price,
                    quantity=event.quantity,
                )
            }

            is ProductEvent.EditFixedProductSet->{
                editFixedProductSets(
                    id=state.value.selectedProduct?.id?:"",
                    sets=state.value.productSets?.sets,
                    categoryId=state.value.selectedProductSet?.category?.id?:"",
                    productId=event.productId,
                    price=event.price,
                    quantity=event.quantity,
                )
            }

            is ProductEvent.DeleteFixedProductSet->{
                removeFixedProductSets(
                    id=state.value.selectedProduct?.id?:"",
                    sets=state.value.productSets?.sets,
                    categoryId=state.value.selectedProductSet?.category?.id?:"",
                    fixedProduct=state.value.selectedFixedProductSet,
                )
            }

            is ProductEvent.DeleteProductSets->{
                deleteProductSets(
                    selectedProductSet=state.value.selectedProductSet,
                    sets=state.value.productSets?.sets,
                )
            }

            is ProductEvent.SetDeleteProductSetDialogStatus->{
                _state.value=_state.value.copy(
                    showDeleteProductSetDialog = event.status
                )
            }

            is ProductEvent.OnProductSetItemClick->{
                onProductSetItemClick(id=event.id)
            }

            is ProductEvent.CreateSpecialPrice->{
                createSpecialPrice(
                    productId = state.value.selectedProduct?.id?:"",
                    name=event.name,
                    startTime=event.startTime,
                    dateFrom=event.dateFrom,
                    type=event.type
                )

            }
            is ProductEvent.GetProductSets->{
                getProductSet(id=event.id)
            }

            is ProductEvent.OnSearchInProductSets->{
                onSearchInProductSets(title=event.searchValue)
            }


            is ProductEvent.SetDeletePriceDialogStatus->{
                _state.value=_state.value.copy(
                    showDeletePriceDialog = event.status
                )
            }

            is ProductEvent.OnSearchInPrices->{
                onSearchInPrices(searchValue=event.title)
            }

            is ProductEvent.DeleteSpecialPrice->{
                deleteSpecialPrice(
                    id = state.value.selectedPrice?.id?:""
                )
            }
            is ProductEvent.UpdateSpecialPrice->{
                updateSpecialPrice(
                    id = state.value.selectedPrice?.id?:"",
                    title = event.title,
                    value = event.value
                )
            }
            is ProductEvent.OnPriceItemClick->{
                onPriceItemClick(event.id)
            }

            is ProductEvent.GetPriceLevels->{
                getPriceLevels()
            }
            is ProductEvent.SetAddPriceDialogStatus->{
                _state.value=_state.value.copy(
                    showAddPriceDialog = event.status
                )
            }

            is ProductEvent.CreateProductIngredients->{
                createProductIngredients(
                    name=event.name,
                    keyword=event.keyword,
                    number=event.number,
                    unit=event.unit,
                )
            }

            is ProductEvent.SetCreateAlergeneComponentStatus->{
                _state.value=_state.value.copy(
                    showAddNewAlergeneComponent = event.status
                )
            }

            is ProductEvent.SetCreateCustomAlergeneDialogStatus->{
                _state.value=_state.value.copy(
                    showCreateCustomAllergeneDialog = event.status
                )
            }

            is ProductEvent.DismissErrorDialog->{
                _state.value=_state.value.copy(
                    errorInfo = null,
                )
            }

            is ProductEvent.OnSubmitKitchenInfoDialog->{
                submitKitchenInfoDialog(
                    id = event.id,
                    name=event.name,
                    variants=event.variants,
                )
            }

            is ProductEvent.OnAddKitchenItemIconClick->{
                onAddKitchenItemIconClick()
            }
            is ProductEvent.OnEditKitchenItemIconClick->{
                onEditKitchenItemIconClick()
            }
            is ProductEvent.OnDeleteKitchenItemIconClick->{
                onDeleteKitchenItemIconClick()
            }

            is ProductEvent.OnCancelKitchenItemDialog->{
                onCancelKitchenItemDialog()
            }

            is ProductEvent.OnRefreshKitchenInfoClick->{
                onRefreshKitchenInfoClick()
            }
            is ProductEvent.OnKitchenInfoItemClick->{
                onKitchenInfoItemClick(info=event.info)
            }

            is ProductEvent.OnSearchKitchenInfo->{
                searchInKitchenInfo(value=event.value)
            }

            is ProductEvent.GetKitchenInfo->{
                getKitchenInfo()
            }
            is ProductEvent.DismissDeleteKitchenInfoDialogStatus->{
                _state.value=_state.value.copy(
                    showDeleteKitchenItemDialog=false
                )
            }
            is ProductEvent.DeleteKitchenInfo->{
                deleteKitchenInfo(id=event.id)
            }

            is ProductEvent.SetFilterProductItemsComponentStatus->{
                _state.value=_state.value.copy(
                    showProductItemsFilterComponent = event.status
                )
            }

            is ProductEvent.SubmitFilterProductItems->{
                submitProductFilterItems(type=state.value.selectedProductFilterItemsType)
            }
            is ProductEvent.SelectProductFilterType->{
                _state.value=_state.value.copy(selectedProductFilterItemsType = event.type)
            }

            is ProductEvent.RefreshProductsCategoryList->{
                refreshProductCategoryList()
            }
            is ProductEvent.GetProductsCategoryList->{
                getProductCategoryList( )

            }

            is ProductEvent.GetCachedBidImg->{
                getCashBidImg(
                    imageUrl = event.imageUrl,
                    key = event.key
                )

            }

            is ProductEvent.GetCheckedIngredients->{
                getCheckedIngredients(
                    productId=state.value.selectedProduct?.id?:"",
                )
            }
            is ProductEvent.UpdateAllergenContent->{
                updateAllergenContent(
                    ingredientId = event.ingredientId,
                    dataValue=event.content,
                    productId=state.value.selectedProduct?.id?:""
                )
            }


            is ProductEvent.GetCompanyProfileId->{

                getCompanyProfileId()


            }

            is ProductEvent.OnProductItemClick -> {
                onProductClick(
                    productId = event.id,
                    switchTheSecondPage =event.switchTheSecondPage
                )
            }

            is ProductEvent.UpdateProductInfo -> {
                updateProductInfo(
                    dataValue = event.value,
                    dataTitle = event.title,
                    id = state.value.selectedProduct?.id?:"",
                )
            }
            is ProductEvent.UpdateProductPrice -> {
                updateProductPrice(
                    dataValue = event.value,
                    dataTitle = event.title,
                    id = state.value.selectedProduct?.id?:"",
                )
            }

            is ProductEvent.UpdateProductProperties -> {
                updateProductProperties(
                    id = state.value.selectedProduct?.id?:"",
                    minOrder = event.minOrder,
                    maxOrder=event.maxOrder,
                    timeLeadDays=event.timeLeadDays,
                )
            }

            is ProductEvent.OnKitchenInfoTitleClick->{
                onKitchenInfoTitleClick()

            }

            is ProductEvent.UpdateRestaurantData -> {
                updateRestaurantData(
                    dataValue = event.value,
                    dataTitle = event.title,
                    id = state.value.selectedProduct?.id?:"",
                )
            }
            is ProductEvent.SetLocalCashBidImg->
            {
                _state.value=_state.value.copy(
                    cashBidImgAIGeneratorUrl = event.url,
                )
            }

            is ProductEvent.OnSelectCashBidImg-> {
                selectCashBidImg(
                    id=event.id,
                    img=event.url,
                )
            }

            is ProductEvent.OnChangeAiImageDescription->{
                _state.value=_state.value
                    .copy(imageAiGeneratorDescription = event.value)
            }

            is ProductEvent.UpdateCheckout -> {
                updateProductCheckout(
                    dataValue = event.dataValue,
                    id = state.value.selectedProduct?.id ?: ""
                )
            }

            is ProductEvent.GetCheckoutData -> {

                getCheckoutData( )
            }

            is ProductEvent.GetRestaurantData -> {
                getRestaurantData(
                    id = state.value.selectedProduct?.id?:"",
                )
            }

            is ProductEvent.GetPrinterLocationNames->{
                getPrintersLocation( )
            }

            is ProductEvent.GetProductSalesGroup ->{
                getProductSalesGroup()
            }
            is ProductEvent.GetIngredients->{
                getIngredients( )
            }

            //Search

            is ProductEvent.OnSearchCheckoutItems -> {
                searchCheckoutItems(value = event.value)

            }
            is ProductEvent.OnSearchIngredientItems->{
                searchIngredientItems(value=event.value)
            }

            is ProductEvent.OnSearchProductInputChange ->{
                onMainGridSearchProductInputChange(event.value)
            }




            is ProductEvent.OnMainGridNumberSortClick ->onMainGridNumberSortClick()
            is ProductEvent.OnMainGridTitleSortClick ->onMainGridTitleSortClick()




            //Other
            is ProductEvent.OnTabClick -> {
                onTabClick(selectedTab = event.selectedTab)
            }


            is ProductEvent.OnChangePageClick->changePage()


            is ProductEvent.SetGenerateCashBidAIImgDialogStatus->{
                _state.value=_state.value.copy(
                    showGenerateAIImgDialog = event.status,
                    cashBidImgAIGeneratorUrl = null,
                    submitGeneratedImgLoading = false,
                    isImageAiGeneratorLoading = false,
                )
                if (!event.status){
                    getDishPictureUseCase.cancel()
                    updateProductCashBidImageUseCase.cancel()

                }

            }

            is ProductEvent.GenerateProductCashBidImg->{
                generateProductCashBidImg(
                    description=event.description,
                )
            }

            //Add Record
            is ProductEvent.OnAddRecordIconClick->{
                onAddRecordIconClick()
            }
            is ProductEvent.OnCancelRecordDialogClick->dismissAddRecordDialog()

            is ProductEvent.OnChangeRecordName->onChangeRecordName(event.value)
            is ProductEvent.OnChangeRecordNumber->onChangeRecordNumber(event.value)

            is ProductEvent.OnSubmitAddRecordDialogClick->{
                onSubmitRecordDialogClick(
                    windowMode = event.windowMode,
                    name=state.value.newRecordName,
                    code =state.value.newRecordNumber,
                )

            }


        }


    }

    private fun updateProductSetModel(
        id: String,
        setModel: SetModel?
    ) {
        launch {
            requestHandler(
                loadingState = {
                    _state.value = _state.value.copy(
                        generalDataLoading = it,
                    )
                },
                callRequest = {
                    val transformedSets = state.value.productSets?.sets?.map { set ->
                        if (set.category?.id == state.value.selectedProductSet?.category?.id) {
                            ProductSetData(
                                category = setModel?.category?.id,
                                minQuantity = setModel?.minQuantity,
                                maxQuantity = setModel?.maxQuantity,
                                priceLevel = setModel?.priceLevel,
                                isCollectPoints = setModel?.isCollectPoints,
                                weekDays = setModel?.weekDays,
                                course = setModel?.course,
                                fixProducts = setModel?.fixProducts?.map { product ->
                                    FixProductData(
                                        code = product?.code,
                                        amount = product?.amount,
                                        price = product?.price
                                    )
                                } ?: listOf()
                            )
                        } else {
                            ProductSetData(
                                category = set.category?.id,
                                minQuantity = set.minQuantity,
                                maxQuantity = set.maxQuantity,
                                priceLevel = set.priceLevel,
                                isCollectPoints = set.isCollectPoints,
                                weekDays = set.weekDays,
                                course = set.course,
                                fixProducts = set.fixProducts?.map { product ->
                                    FixProductData(
                                        code = product?.code,
                                        amount = product?.amount,
                                        price = product?.price
                                    )
                                } ?: listOf()
                            )
                        }
                    } ?: listOf()

                    val request = ProductSetRequest(sets = transformedSets)

                    updateProductSetsListUseCase(
                        id = id,
                        sets = request.sets
                    )
                },
                onSuccess = {
                    _state.value = _state.value.copy(
                        selectedProductSet = setModel
                    )
                    getProductSet(
                        id = state.value.selectedProduct?.id ?: "",
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun onFixedProductItemClick(
        code: String,
    )
    {
        _state.value=_state.value.copy(
            selectedFixedProductSet =state.value.selectedProductSet
                ?.fixProducts?.find {
                    it?.code==code
                }
        )
    }

    private fun removeFixedProductSets(
        id: String,
        sets: List<SetModel>?,
        categoryId: String,
        fixedProduct: FixProduct?,
    ) {
        launch {
            requestHandler(
                loadingState = {
                    _state.value = _state.value.copy(
                        deleteFixedProductLoading = it,
                    )
                },
                callRequest = {
                    val transformedSets = sets?.map { set ->
                        if (set.category?.id == categoryId) {
                            ProductSetData(
                                category = set.category.id,
                                minQuantity = set.minQuantity,
                                maxQuantity = set.maxQuantity,
                                priceLevel = set.priceLevel,
                                isCollectPoints = set.isCollectPoints,
                                weekDays = set.weekDays,
                                course = set.course,
                                fixProducts = (set.fixProducts?.map { product ->
                                    FixProductData(
                                        code = product?.code,
                                        amount = product?.amount,
                                        price = product?.price
                                    )
                                }?.toMutableList() ?: mutableListOf()).apply {
                                    remove(FixProductData(
                                        code = fixedProduct?.code,
                                        amount = fixedProduct?.amount,
                                        price = fixedProduct?.price
                                    ))
                                }
                            )
                        } else {
                            ProductSetData(
                                category = set.category?.id,
                                minQuantity = set.minQuantity,
                                maxQuantity = set.maxQuantity,
                                priceLevel = set.priceLevel,
                                isCollectPoints = set.isCollectPoints,
                                weekDays = set.weekDays,
                                course = set.course,
                                fixProducts = set.fixProducts?.map { product ->
                                    FixProductData(
                                        code = product?.code,
                                        amount = product?.amount,
                                        price = product?.price
                                    )
                                } ?: listOf()
                            )
                        }
                    } ?: listOf()

                    val request = ProductSetRequest(sets = transformedSets)

                    updateProductSetsListUseCase(
                        id = id,
                        sets = request.sets
                    )
                },
                onSuccess = {
                    _state.value = _state.value.copy(
                        showDeleteFixedProductDialog = false,
                        selectedProductSet =it.data?.cashAssist?.setProductSets
                            ?.sets?.find {item->
                                item.category?.id==
                                        state.value.selectedProductSet?.category?.id
                            }

                    )
                    getProductSet(
                        id = state.value.selectedProduct?.id ?: "",
                    )

                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }


    private fun editFixedProductSets(
        id: String,
        productId: String,
        price: Double?,
        categoryId: String,
        quantity: Int,
        sets: List<SetModel>?,
    ) {
        launch {
            requestHandler(
                loadingState = {
                    _state.value = _state.value.copy(
                        submitAddEditProductFixLoading = it,
                    )
                },
                callRequest = {
                    val transformedSets = sets?.map { set ->
                        if (set.category?.id == categoryId) {
                            ProductSetData(
                                category = set.category.id,
                                minQuantity = set.minQuantity,
                                maxQuantity = set.maxQuantity,
                                priceLevel = set.priceLevel,
                                isCollectPoints = set.isCollectPoints,
                                weekDays = set.weekDays,
                                course = set.course,
                                fixProducts = set.fixProducts?.map { product ->
                                    if (product?.code==state.value.selectedFixedProductSet?.code) {
                                        FixProductData(
                                            code = productId,
                                            amount = quantity,
                                            price = price
                                        )
                                    } else {
                                        FixProductData(
                                            code = product?.code,
                                            amount = product?.amount,
                                            price = product?.price
                                        )
                                    }
                                } ?: listOf()
                            )
                        } else {
                            ProductSetData(
                                category = set.category?.id,
                                minQuantity = set.minQuantity,
                                maxQuantity = set.maxQuantity,
                                priceLevel = set.priceLevel,
                                isCollectPoints = set.isCollectPoints,
                                weekDays = set.weekDays,
                                course = set.course,
                                fixProducts = set.fixProducts?.map { product ->
                                    FixProductData(
                                        code = product?.code,
                                        amount = product?.amount,
                                        price = product?.price
                                    )
                                } ?: listOf()
                            )
                        }
                    } ?: listOf()

                    val request = ProductSetRequest(sets = transformedSets)

                    updateProductSetsListUseCase(
                        id = id,
                        sets = request.sets
                    )
                },
                onSuccess = {
                    _state.value = _state.value.copy(
                        showEditProductFixDialog = false,
                        selectedFixedProductSet = null,
                        selectedProductSet = it.data?.cashAssist?.setProductSets
                            ?.sets?.find { item ->
                                item.category?.id ==
                                        state.value.selectedProductSet?.category?.id
                            }
                    )
                    getProductSet(
                        id = state.value.selectedProduct?.id ?: "",
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun addFixedProductSets(
        id: String,
        productId: String,
        price: Double?,
        categoryId: String,
        quantity: Int,
        sets: List<SetModel>?,
    ) {
        launch {
            requestHandler(
                loadingState = {
                    _state.value = _state.value.copy(
                        submitAddEditProductFixLoading = it,
                    )
                },
                callRequest = {
                    val transformedSets = sets?.map { set ->
                        if (set.category?.id == categoryId) {
                            ProductSetData(
                                category = set.category.id,
                                minQuantity = set.minQuantity,
                                maxQuantity = set.maxQuantity,
                                priceLevel = set.priceLevel,
                                isCollectPoints = set.isCollectPoints,
                                weekDays = set.weekDays,
                                course = set.course,
                                fixProducts = (set.fixProducts?.map { product ->
                                    FixProductData(
                                        code = product?.code,
                                        amount = product?.amount,
                                        price = product?.price
                                    )
                                }?.toMutableList() ?: mutableListOf()).apply {

                                    add(FixProductData(
                                        code = productId,
                                        amount = quantity,
                                        price = price
                                    ))
                                }
                            )
                        } else {
                            ProductSetData(
                                category = set.category?.id,
                                minQuantity = set.minQuantity,
                                maxQuantity = set.maxQuantity,
                                priceLevel = set.priceLevel,
                                isCollectPoints = set.isCollectPoints,
                                weekDays = set.weekDays,
                                course = set.course,
                                fixProducts = set.fixProducts?.map { product ->
                                    FixProductData(
                                        code = product?.code,
                                        amount = product?.amount,
                                        price = product?.price
                                    )
                                } ?: listOf()
                            )
                        }
                    } ?: listOf()

                    val request = ProductSetRequest(sets = transformedSets)

                    updateProductSetsListUseCase(
                        id = id,
                        sets = request.sets
                    )
                },
                onSuccess = {
                    _state.value = _state.value.copy(
                        showAddProductFixDialog = false,
                        selectedProductSet =it.data?.cashAssist?.setProductSets
                            ?.sets?.find {item->
                                item.category?.id==
                                        state.value.selectedProductSet?.category?.id
                            }

                    )
                    getProductSet(
                        id = state.value.selectedProduct?.id ?: "",
                    )

                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun onSearchInFixedProducts(searchValue: String) {

        val searchTerm = searchValue.trim().lowercase()
        val data =tempFixedProducts.filterNotNull()?.filter { product ->
            product.price?.toString()?.lowercase()?.contains(searchTerm) == true ||
                    product.amount?.toString()?.lowercase()?.contains(searchTerm) == true ||
                    product.code?.lowercase()?.contains(searchTerm) == true ||
                    state.value.productsInfo.find {
                        it.id==product.code
                    }?.name?.lowercase()?.contains(searchTerm)==true
        }

        _state.value = _state.value.copy(
            selectedProductSet = state.value.selectedProductSet?.copy(
                fixProducts = if (searchTerm.isEmpty()) tempFixedProducts
                    else data
            )
        )

    }

    private fun addProductSets(
        id:String,
        categoryId: String,
        sets: List<SetModel>?,
    ) {
        launch {
            requestHandler(
                loadingState = {
                    _state.value = _state.value.copy(
                        createNewProductSetLoading = it,
                    )
                },
                callRequest = {

                    val transformedSets = (sets?.map { set ->
                        ProductSetData(
                            category = set.category?.id ,
                            minQuantity = set.minQuantity,
                            maxQuantity = set.maxQuantity,
                            priceLevel = set.priceLevel,
                            isCollectPoints = set.isCollectPoints,
                            weekDays = set.weekDays,
                            course = set.course ,
                            fixProducts = set.fixProducts?.map { product ->
                                FixProductData(
                                    code = product?.code,
                                    amount = product?.amount,
                                    price = product?.price
                                )
                            } ?: listOf()
                        )
                    } ?: listOf()).toMutableList()

                    transformedSets.add(
                        ProductSetData(
                            category = categoryId,
                            minQuantity =null,
                            maxQuantity =null,
                            priceLevel =null,
                            isCollectPoints =false,
                            weekDays =0,
                            course = null,
                            fixProducts = listOf(),

                        )
                    )

                    val request = ProductSetRequest(sets = transformedSets)

                    updateProductSetsListUseCase(
                        id = id,
                        sets = request.sets
                    )
                },
                onSuccess = {
                    _state.value = _state.value.copy(
                        showCreateNewProductSetDialog = false,
                    )
                    getProductSet(id=state.value.selectedProduct?.id?:"")
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun deleteProductSets(
        selectedProductSet: SetModel?,
        sets: List<SetModel>?,
    ) {
        launch {
            requestHandler(
                loadingState = {
                    _state.value = _state.value.copy(
                        deleteProductSetLoading = it,
                    )
                },
                callRequest = {
                    val data = sets?.toMutableList()
                    data?.remove(state.value.selectedProductSet)
                    _state.value=_state.value.copy(selectedProductSet = null)

                    val transformedSets = data?.map { set ->
                        ProductSetData(
                            category = set.category?.id ,
                            minQuantity = set.minQuantity,
                            maxQuantity = set.maxQuantity,
                            priceLevel = set.priceLevel,
                            isCollectPoints = set.isCollectPoints,
                            weekDays = set.weekDays,
                            course = set.course ,
                            fixProducts = set.fixProducts?.map { product ->
                                FixProductData(
                                    code = product?.code,
                                    amount = product?.amount,
                                    price = product?.price
                                )
                            } ?: listOf()
                        )
                    } ?: listOf()

                    val request = ProductSetRequest(sets = transformedSets)

                    updateProductSetsListUseCase(
                        id = selectedProductSet?.category?.id ?: "",
                        sets = request.sets
                    )
                },
                onSuccess = {
                    _state.value = _state.value.copy(
                        showDeleteProductSetDialog = false
                    )
                    getProductSet(id=state.value.selectedProduct?.id?:"")
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun onSearchInProductSets(title: String) {
        _state.value=_state.value.copy(
            productSets =state.value.productSets?.copy(
                sets = temptProductSets.filter {
                    it.category?.name?.lowercase()
                        ?.contains(title.lowercase())?:false
                }
            )

        )
    }

    private fun onProductSetItemClick(id: String)
    {
        _state.value=_state.value.copy(
            selectedProductSet=state.value.productSets?.sets
                ?.find { it.category?.id==id },
            selectedFixedProductSet=null,
        )
        tempFixedProducts=state.value.selectedProductSet?.fixProducts?: listOf()

    }

    private fun updateProductSets(
        id: String,
        title: String,
        value: dynamic,
    ) {
        launch {
            requestHandler(
                loadingState = {
                    _state.value=_state.value.copy(
                        generalDataLoading =it,
                    )
                },
                callRequest = {
                    updateProductSetUseCase(
                        id=id,
                        title=title,
                        value=value
                    )
                },
                onSuccess = {
                    val data=it.data?.cashAssist?.updateProduct
                    _state.value=_state.value.copy(
                        productSets = data
                    )
                    temptProductSets=data?.sets?: listOf()
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun getProductSet(id: String)
    {
        launch {
            requestHandler(
                loadingState = {
                    _state.value=_state.value.copy(
                        generalDataLoading = it,
                    )
                },
                callRequest = {
                    getProductSetUseCase(id)
                },
                onSuccess = {
                    val data=it.data?.cashAssist?.getProduct
                    _state.value=_state.value.copy(
                        productSets = data
                    )
                    temptProductSets=data?.sets?: listOf()
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun onSearchInPrices(searchValue: String) {

        _state.value=_state.value.copy(
            specialPrices =tempPrices.filter {
                it.name?.contains(searchValue)?:false
            }
        )
    }

    private fun createSpecialPrice(
        name: String,
        productId: String,
        dateFrom: String,
        type: Int,
        startTime: String
    ) {
        launch {
            requestHandler(
                loadingState = {
                    _state.value=_state.value.copy(
                        createSpecialPriceLoading=it
                    )
                },
                callRequest = {
                    createSpecialPriceUseCase(
                        name=name,
                        productId = productId,
                        type = type,
                        dateFrom = dateFrom,
                        startTime=startTime,
                    )
                },
                onSuccess = {
                    refreshSpecialPrices(
                        deSelectPrice=false
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }


    }

    private fun updateSpecialPrice(
        id:String,
        title:String,
        value:dynamic,
    )
    {
        launch {
            requestHandler(
                loadingState ={
                    _state.value=_state.value.copy(
                        generalDataLoading = it
                    )
                } ,
                callRequest = {
                    updateSpecialPriceUseCase(
                        id=id,
                        title=title,
                        value = value,
                    )
                },
                onSuccess = {
                    _state.value=_state.value.copy(
                        selectedPrice = it.data?.cashAssist?.updatedPrice
                    )
                    refreshSpecialPrices(
                        deSelectPrice=false
                    )

                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }

            )
        }

    }

    private fun deleteSpecialPrice(
        id: String,
    ) {
        launch {
            requestHandler(
                loadingState ={
                    _state.value=_state.value.copy(
                        deletePriceLoading = it
                    )
                } ,
                callRequest = {
                    updateSpecialPriceUseCase(
                        id=id,
                        title=ApiUtils.Field.isActive,
                        value = false,
                    )
                },
                onSuccess = {
                    refreshSpecialPrices(
                        deSelectPrice=true
                    )

                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }

            )
        }
        

    }

    private fun refreshSpecialPrices(
        deSelectPrice:Boolean
    ) {
        launch {
            requestHandler(
                callRequest = {
                    singleProductUseCase(
                        id = state.value.selectedProduct?.id ?: ""
                    )
                },
                onSuccess = {
                    _state.value = _state.value.copy(
                        specialPrices = it.data?.cashAssist
                            ?.getProduct?.specialPrices,
                        showDeletePriceDialog = false,
                        showAddPriceDialog = false,
                    )
                    tempPrices=it.data?.cashAssist
                        ?.getProduct?.specialPrices?: listOf()

                    if (deSelectPrice){
                        _state.value=_state.value.copy(
                            selectedPrice=null
                        )
                    }
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }

            )

        }
    }



    private fun onPriceItemClick(id: String) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(
                        generalDataLoading = isLoading
                    )
                },
                callRequest = {
                    getSpecialPriceUseCase(id)
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        selectedPrice = result.data?.cashAssist?.getSpecialPrice,
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun getPriceLevels() {
        if (state.value.priceLevels == null) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->

                    },
                    callRequest = {
                        priceLevelsUseCase()
                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(
                            priceLevels = result.data?.cashAssist?.getAppConfigAdditional?.priceLevels
                        )
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }

    private fun deleteKitchenInfo(
        id:String,
    ) {
        launch {
            requestHandler(
                loadingState = {
                    _state.value=_state.value.copy(
                        deleteKitchenItemLoading = it
                    )
                },
                callRequest = {
                    deleteProductAdditionUseCase(
                        id = id
                    )
                },
                onSuccess = {
                    _state.value=_state.value.copy(
                        showDeleteKitchenItemDialog = false
                    )
                    getKitchenInfo()
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }



    }

    private fun onDeleteKitchenItemIconClick() {
        if (state.value.selectedKitchenInfoItem!=null){
            _state.value=_state.value.copy(
                showDeleteKitchenItemDialog=true
            )
        }

    }

    private fun onEditKitchenItemIconClick() {
        if (state.value.selectedKitchenInfoItem!=null){
            _state.value=_state.value.copy(
                showKitchenAddOrEditItemDialog = true
            )
        }

    }

    private fun getCompanyProfileId() {
        val result = getCompanyProfileIdUseCase()
        _state.value = _state.value.copy(
            companyProfileId = result
        )
    }

    private fun createProductIngredients(
        name: String,
        keyword: String,
        number: String,
        unit: String
    ) {
        launch {
            requestHandler(
                loadingState = {
                    _state.value=_state.value.copy(
                        createCustomAllergeneLoading=it
                    )
                },
                callRequest = {
                    createProductIngredientUseCase(
                        productId = state.value.selectedProduct?.id?:"",
                        name=name,
                        keyword=keyword,
                        number=number,
                        unit = unit,
                    )   
                },
                onSuccess = {
                    _state.value=_state.value.copy(
                        createCustomAllergeneLoading=false,
                        showCreateCustomAllergeneDialog = false,
                        showAddNewAlergeneComponent = false
                    )
                    getIngredients(refresh = true)
                }
                ,onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            ) 

        }


    }


    private fun getUnitSells() {
        launch {
            requestHandler(
                condition = state.value.unitSells == null,
                loadingState = { isLoading -> },
                callRequest = {
                    loadAppConstantsUseCase(
                        type = IdUtils.unitSales,
                        language = LanguageEnum.German.name
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        unitSells = result.data?.cashAssist?.loadAppConstants
                    )
                },
                onError = { result -> 
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun submitKitchenInfoDialog(
        id:String,
        name: String,
        variants: List<String?>
    ) {
        if (state.value.selectedKitchenInfoItem==null){
            addKitchenInfoItem(
                name=name,
                variants=variants
            )

        }else{
            updateKitchenInfoItem(
                id = id,
                name=name,
                variants=variants,
            )
        }

    }


    private fun addKitchenInfoItem(
        name: String,
        variants: List<String?>,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(kitchenInfoDialogLoading = isLoading)
                },
                callRequest = {
                    createProductAdditionUseCase(
                        name = name,
                        variants = variants,
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        kitchenInfoDialogLoading = false,
                        showKitchenAddOrEditItemDialog = false,
                    )
                    getKitchenInfo()
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun updateKitchenInfoItem(
        id: String,
        name: String,
        variants: List<String?>
    )  {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(
                        kitchenInfoDialogLoading = isLoading
                    )
                },
                callRequest = {
                    updateProductAdditionUseCase(
                        id = id,
                        name = name,
                        variants = variants
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        showKitchenAddOrEditItemDialog = false,
                        kitchenInfoDialogLoading = false,
                    )
                    getKitchenInfo()
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun onRefreshKitchenInfoClick() {
        _state.value = _state.value.copy(kitchenInfo = tempKitchenInfo)
    }

    private fun onCancelKitchenItemDialog() {
        _state.value = _state.value.copy(
            showKitchenAddOrEditItemDialog = false,
            selectedKitchenInfoItem = null
        )
        createProductAdditionUseCase.cancel()
        updateProductAdditionUseCase.cancel()
    }

    private fun onAddKitchenItemIconClick() {
        _state.value = _state.value.copy(
            showKitchenAddOrEditItemDialog = true,
            selectedKitchenInfoItem = null
        )
    }

    private fun onKitchenInfoItemClick(info: ProductAdditions?) {
        _state.value=_state.value.copy(
            selectedKitchenInfoItem = info,
        ) 
    }

    private fun searchInKitchenInfo(value:String) {
        _state.value = _state.value.copy(kitchenInfo = tempKitchenInfo)
        val newData = _state.value.kitchenInfo?.filter { model ->
            model?.name?.contains(value, ignoreCase = true) ?: false
        }
        _state.value = _state.value.copy(kitchenInfo = newData)
    }

    private fun onKitchenInfoTitleClick()
    {
        when (state.value.restaurantTempItemsDescendingSort) {
            false -> {
                _state.value = _state.value.copy(
                    kitchenInfo = state.value.kitchenInfo?.sortedByDescending { it?.name?.lowercase() },
                    restaurantTempItemsDescendingSort = true
                )
            }

            true -> {
                _state.value = _state.value.copy(
                    kitchenInfo = state.value.kitchenInfo?.sortedBy { it?.name?.lowercase() },
                    restaurantTempItemsDescendingSort = false
                )
            }

            null -> {
                _state.value = _state.value.copy(
                    kitchenInfo = state.value.kitchenInfo?.sortedBy { it?.name?.lowercase() },
                    restaurantTempItemsDescendingSort = false
                )
            }
        }
    }


    private fun getCashBidImg(
        imageUrl:MutableState<String?>,
        key:String
    ) {
        launch {
            requestHandler(
                callRequest = {
                    imgUrlUseCase(key)
                },
                onSuccess = { result ->
                    imageUrl.value = result
                    _state.value=_state.value.copy(showGenerateAIImgDialog = false)
                },
            )
        }

    }


    private fun getKitchenInfo( )
    {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(
                        addNewProductLoadingProgressBar = isLoading
                    )
                },
                callRequest = {
                    kitchenInfoUseCase()
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        kitchenInfo = result.data?.cashAssist?.listProductAdditions
                    )
                    tempKitchenInfo = state.value.kitchenInfo
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }

    }

    private fun submitProductFilterItems(type: GridItemsFilterEnum) {

        getCachedProductCategoriesUseCase {
            when(type){
                GridItemsFilterEnum.ALL_ITEMS->{
                    _state.value=_state.value.copy(
                        productsInfo = it?: listOf(),
                        showProductItemsFilterComponent=false,
                    )


                }
                GridItemsFilterEnum.ACTIVE_ITEMS->{
                    _state.value=_state.value.copy(
                        productsInfo = it?.filter {model->
                            model.isActive?:false
                        }?: listOf(),
                        showProductItemsFilterComponent=false,
                    )


                }
                GridItemsFilterEnum.INACTIVE_ITEMS->{
                    _state.value=_state.value.copy(
                        productsInfo = it?.filter {model->
                            model.isActive==false || model.isActive==null
                        }?: listOf(),
                        showProductItemsFilterComponent=false,
                    )


                }
            }
        }




    }


    private fun onSubmitRecordDialogClick(
        name: String,
        code: String,
        windowMode: WindowSizeModeEnum,
    ) {

        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(
                        addNewProductLoadingProgressBar = isLoading
                    )
                },
                callRequest = {
                    addProductUseCase(
                        name =name,
                        code =code,
                    )
                },
                onSuccess = { result ->
                    val model = result.data?.cashAssist?.createMutation

                    val newItem = ProductItem(
                        checkOutCommandId = "",
                        code = code,
                        fAProductId = "",
                        id = model?.id ?: "",
                        isActive = model?.isActive ?: false,
                        name = model?.name,
                        price = model?.price,
                        priceInCafe = model?.priceInCafe,
                    )

                    addProductCategoryToDBUseCase(newItem)

                    _state.value = _state.value.copy(
                        showAddRecordDialog = false,
                        checkedIngredients = listOf(),
                        productsInfo = state.value.productsInfo + newItem,
                        productSalesGroup = listOf(),
                        selectedProduct = state.value.selectedProduct?.copy(
                            id = model?.id ?: "",
                            cashRegisterId = model?.cashRegisterId ?: listOf(),
                            isActive = model?.isActive ?: false,
                            name = model?.name ?: "",
                            code = code,
                            codeMWSt = AppConstantsEnum.VAT_NORMAL.value,
                            codeMWSt2 = AppConstantsEnum.VAT_NORMAL.value,
                            img = null,
                            isNetto = false,
                            isEmployeeArticle = false,
                            isNettoForUser = false,
                            price = model?.price,
                            priceInCafe = model?.priceInCafe,
                            properties = Properties(
                                clickCollectLeadDaysCount = null,
                                clickCollectOrderMax = null,
                                clickCollectOrderMin = null,
                            ),
                            salesGroupId = null
                        ),
                        newRecordName = "",
                        newRecordNumber = "",
                        firstPageActive = windowMode != WindowSizeModeEnum.PHONE
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }

    }

    private fun onChangeRecordNumber(value: String) {
        _state.value=_state.value.copy(
            newRecordNumber = value,
        )
        checkAddRecordSubmitClickable()
    }

    private fun onChangeRecordName(value: String) {
        _state.value=_state.value.copy(
            newRecordName = value,
        )
        checkAddRecordSubmitClickable()
    }

    private fun checkAddRecordSubmitClickable(){
        if (
            state.value.newRecordNumber.isNotEmpty()
            && state.value.newRecordName.isNotEmpty()
        ){
            _state.value=_state.value.copy(
                isAddNewRecordSubmitClickable = true
            )
        }else _state.value=_state.value.copy(
            isAddNewRecordSubmitClickable = false
        )
    }

    private fun dismissAddRecordDialog() {
        _state.value=_state.value.copy(
            showAddRecordDialog = false,
            addNewProductLoadingProgressBar = false
        )
        addProductUseCase.cancel()
    }

    private fun onAddRecordIconClick() {
        _state.value=_state.value.copy(
            showAddRecordDialog = true
        )
    }


    private fun getCheckedIngredients(productId: String) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(generalDataLoading = isLoading)
                },
                callRequest = {
                    checkedIngredientsUseCase(productId = productId)
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        checkedIngredients = result
                            ?.data?.cashAssist?.getProduct?.ingredients ?: listOf()
                    )
                },
                onException = { e ->
                    _state.value = _state.value.copy(
                        checkedIngredients = listOf()
                    )
                    showException(e)
                },
                onError = { result ->
                    _state.value = _state.value.copy(
                        checkedIngredients = listOf() ,
                    )
                    showRequestError(result?.errors)

                },
            )
        }
    }

    private fun updateAllergenContent(
        dataValue: Boolean,
        ingredientId: String,
        productId: String
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(
                        generalDataLoading = isLoading
                    )
                },
                callRequest = {
                    updateAllergenUseCase(
                        productId = productId,
                        dataValue = dataValue,
                        ingredientId = ingredientId
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        checkedIngredients = result.data?.cashAssist
                            ?.updateProduct?.ingredients
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun generateProductCashBidImg(description: String) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value
                        .copy(isImageAiGeneratorLoading = isLoading)
                },
                callRequest = {
                    getDishPictureUseCase(description = description)
                },
                onSuccess = { result ->
                    val imageDataUrl = "data:image/jpeg;base64,$result"
                    _state.value = _state.value.copy(
                        cashBidImgAIGeneratorUrl = imageDataUrl
                    )
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun selectCashBidImg(
        id: String,
        img: String?
    ) {
        launch {
            requestHandler(
                condition = img!=null,
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(submitGeneratedImgLoading = isLoading)
                },
                callRequest = {
                    updateProductCashBidImageUseCase(
                        id = id,
                        image = img?:""
                    )
                },
                onSuccess = { result ->
                    val model = result.data?.cashAssist?.img
                    _state.value = _state.value.copy(
                        cashBidImgAIGeneratorUrl = null,
//                        showGenerateAIImgDialog = false,
                        selectedProduct = state.value.selectedProduct
                            ?.copy(
                                img = Img(
                                    key = model?.key ?: "",
                                    uid = model?.uid ?: ""
                                )
                            )
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun changePage() {
        _state.value=_state.value.copy(
            firstPageActive = !_state.value.firstPageActive,
        )
    }



    private fun onMainGridNumberSortClick() {
        val newData:List<ProductItem>
        if (_state.value.isMainGridNumberSortedAsc) {
            newData=_state.value.productsInfo.sortedByDescending { it.code }
        }else{
            newData=_state.value.productsInfo.sortedBy { it.code }.toList()
        }
        _state.value=_state.value.copy(
            productsInfo = newData,
            isMainGridNumberSortedAsc =!_state.value.isMainGridNumberSortedAsc,
            showMainGridNumberSortIcon = true,
            showMainGridNameSortIcon = false
        )
    }

    private fun onMainGridTitleSortClick() {
        val newData:List<ProductItem>
        if (_state.value.isMainGridNameSortedAsc) {
            newData=_state.value.productsInfo.sortedByDescending { it.name?.lowercase() }
        }else{
            newData=_state.value.productsInfo.sortedBy { it.name?.lowercase() }.toList()
        }
        _state.value=_state.value.copy(
            productsInfo = newData,
            isMainGridNameSortedAsc =!_state.value.isMainGridNameSortedAsc,
            showMainGridNameSortIcon = true,
            showMainGridNumberSortIcon = false
        )
    }

    private var searchJob: Job? = null

    private fun onMainGridSearchProductInputChange(value: String) {
        searchJob?.cancel()

        _state.value = _state.value.copy(
            mainGridSearchValue = value
        )
        searchJob = launch {
            _state.value=_state.value.copy(
                productCategoryListLoading = true
            )
            delay(Constants.delayDefaultProcess)

            getCachedProductCategoriesUseCase { products ->
              launch {
                    val filteredList = products?.let { originalList ->
                        val typeFiltered = if (state.value.selectedProductFilterItemsType.value != null) {
                            originalList.filter { model ->
                                model.isActive == state.value.selectedProductFilterItemsType.value
                            }
                        } else originalList

                        if (value.isNotEmpty()) {
                            val searchTerm = value.lowercase()
                            typeFiltered.filter { model ->
                                model.name?.lowercase()?.contains(searchTerm) == true ||
                                        model.code?.lowercase()?.contains(searchTerm) == true
                            }
                        } else typeFiltered
                    }

                    withContext(Dispatchers.Main) {
                        _state.value = _state.value.copy(
                            productsInfo = filteredList ?: listOf(),
                            productCategoryListLoading = false
                        )
                    }
                }
            }
        }
    }

    private fun refreshProductCategoryList(selectedProductId: String? = null) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(
                        generalDataLoading = isLoading,// productCategoryListLoading = isLoading
                    )
                },
                callRequest = {
                    productCategoriesUseCase()
                },
                onSuccess = { result ->
                    val productItems = result.data?.cashAssist
                        ?.listProducts?.items ?: listOf()

                    saveCachedProductCategoriesUseCase(productItems)

                    _state.value = _state.value.copy(
                        productsInfo =if(state.value.selectedProductFilterItemsType.value==null)
                                productItems
                            else productItems.filter { model ->
                                model.isActive ==state.value.selectedProductFilterItemsType.value
                            },
                        mainGridSearchValue = ""
                    )

                    if (state.value.productsInfo.isNotEmpty() && selectedProductId == null) {
                        onProductClick(
                            productId = selectedProductId ?: state.value.productsInfo[0].id
                        )
                    }
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }



    private fun getProductCategoryList(  )
    {
        _state.value = _state.value.copy(
            productCategoryListLoading = true
        )
        getCachedProductCategoriesUseCase{result->

            if (result.isNullOrEmpty()){
                refreshProductCategoryList( )
            }
            else {
                launch {
                    _state.value=_state.value.copy(productsInfo = result
                        .filter { it.isActive==true },
                        productCategoryListLoading = false
                    )
                    if (
                        state.value.productsInfo.isNotEmpty()
                        && state.value.selectedProduct?.id == null
                    ) {
                        onProductClick(
                            productId = state.value.productsInfo[0].id,
                        )
                    }


                }
            }
        }


    }



    private fun searchIngredientItems(value: String) {
        _state.value= _state.value.copy(ingredients =tempIngredients )

        val newData=_state.value.ingredients?.filter {model ->
            model.name?.lowercase()?.contains(value, ignoreCase = true) ?: false
        }
        _state.value=_state.value.copy(
            ingredients = newData
        )

    }

    private fun getIngredients(
        refresh:Boolean=false
    ) {
        launch {
            requestHandler(
                condition = if (refresh) true else
                    state.value.ingredients == null,
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(generalDataLoading = isLoading)
                },
                callRequest = {
                    ingredientListUseCase()
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        ingredients = result.data.cashAssist.listIngredients
                    )
                    tempIngredients = state.value.ingredients
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }


    private fun getProductSalesGroup() {
        launch {
            requestHandler(
                condition = state.value.productSalesGroup == null,
                callRequest = {
                    productSaleGroupUseCase()
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        productSalesGroup = result.data.cashAssist.listSalesGroups.items
                            .sortedBy { it.name }
                            .toList()
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun getPrintersLocation() {
        launch {
            requestHandler(
                condition = state.value.printersLocation == null,
                callRequest = {
                    printerLocationNamesUseCase()
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        printersLocation = result.data.cashAssist.getAppConfig
                            ?.cashRegisterGlobal?.printerLocations
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun updateRestaurantData(
        dataValue: dynamic,
        dataTitle: String,
        id: String
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(generalDataLoading = isLoading)
                },
                callRequest = {
                    updateProductRestaurantUseCase(
                        productId = id,
                        dataTitle = dataTitle,
                        dataValue = dataValue
                    )
                },
                onSuccess = { result ->
                    val model = result.data?.cashAssist?.updateProduct
                    _state.value = _state.value.copy(
                        restaurantData = state.value.restaurantData?.copy(
                            isAdditionRequired = model?.isAdditionRequired,
                            isPrintOnlyInCafe = model?.isPrintOnlyInCafe,
                            printerLocations = model?.printerLocations?: listOf(),
                            additions = model?.additions ?: listOf()
                        )
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun getRestaurantData(id: String) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(generalDataLoading = isLoading)
                },
                callRequest = {
                    productRestaurantUseCase(id = id)
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        restaurantData = result.data.cashAssist.getProduct
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun searchCheckoutItems(value: String) {
        if (value.isEmpty()) {
            _state.value = _state.value.copy(
                cashList = tempCheckoutList,
                checkOutExpandAll = false
            )
            return
        }

        val searchTerm = value.lowercase()
        val searchedList = tempCheckoutList?.mapNotNull { model ->
            val filteredChildrenX = model.children?.mapNotNull { childX ->
                val filteredChildrenXX = childX.children?.mapNotNull { childXX ->
                    val filteredChildrenXXX = childXX.children.filter { childXXX ->
                        childXXX.name?.lowercase()?.contains(searchTerm) == true
                    }

                    if (childXX.name?.lowercase()?.contains(searchTerm) == true
                        || filteredChildrenXXX.isNotEmpty()) {
                        childXX.copy(children = filteredChildrenXXX)
                    } else null
                }

                if (childX.name?.lowercase()?.contains(searchTerm) == true ||
                    filteredChildrenXX?.isNotEmpty() == true) {
                    childX.copy(children = filteredChildrenXX)
                } else null
            }

            if (model.name?.lowercase()?.contains(searchTerm) == true ||
                filteredChildrenX?.isNotEmpty() == true) {
                model.copy(children = filteredChildrenX)
            } else null
        }

        _state.value = _state.value.copy(
            cashList = searchedList,
            checkOutExpandAll = true
        )
    }

    private fun getCheckoutData(  ) {
        launch {
            if (state.value.cashList==null){

                val result=getSavedCheckOutUseCase()

                _state.value=_state.value.copy(
                    cashList = result?.data?.cashAssist?.children
                )
                tempCheckoutList=state.value.cashList
            }

        }

    }

    private fun updateProductCheckout(
        dataValue: MutableSet<String>,
        id: String,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(generalDataLoading = isLoading)
                },
                callRequest = {
                    updateProductCheckoutUseCase(
                        userId = id,
                        dataValue = dataValue,
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        selectedProduct = state.value.selectedProduct?.copy(
                            cashRegisterId = result.data.cashAssist.updateProduct?.cashRegisterId ?: listOf()
                        )
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun updateProductInfo(
        dataTitle: String,
        dataValue: dynamic,
        id: String,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(generalDataLoading = isLoading)
                },
                callRequest = {
                    updateProductUseCase(
                        productId = id,
                        dataTitle = dataTitle,
                        dataValue = dataValue
                    )
                },
                onSuccess = { result ->
                    val item = result.data?.cashAssist?.updateProduct

                    val needsFullRefresh = dataTitle == ApiUtils.Field.code ||
                            dataTitle == ApiUtils.Field.name ||
                            dataTitle == ApiUtils.Field.isActive

                    _state.value = _state.value.copy(
                        selectedSaleGroupId = item?.salesGroupId,
                        selectedVat = item?.codeMWSt,
                        selectedVat2 = item?.codeMWSt2,
                        selectedProduct = state.value.selectedProduct?.copy(
                            code = item?.code,
                            isActive = item?.isActive ?: false,
                            name = item?.name ?: "",
                            isNetto = item?.isNetto,
                            isNettoForUser = item?.isNettoForUser,
                            isEmployeeArticle = item?.isEmployeeArticle,
                        ),
                        imageAiGeneratorDescription = if (needsFullRefresh)
                            item?.name ?: "" else _state.value.imageAiGeneratorDescription,
                        productsInfo = if (needsFullRefresh) {
                            state.value.productsInfo.map { product ->
                                if (product.id == id) {
                                    product.copy(
                                        code = item?.code,
                                        isActive = item?.isActive ?: false,
                                        name = item?.name ?: "",
                                    )
                                } else product
                            }
                        } else state.value.productsInfo
                    )

                    if (needsFullRefresh) {
                        updateProductInCache(
                            productId = id,
                            updatedProduct = item,
                            refreshProductInfoState = dataTitle==ApiUtils.Field.isActive
                        )
                    }

                    if (!needsFullRefresh) {
                        _state.value = _state.value.copy(generalDataLoading = false)
                    }
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun updateProductPrice(
        dataTitle: String,
        dataValue: List<Double?>,
        id: String,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(generalDataLoading = isLoading)
                },
                callRequest = {
                    updateProductPriceUseCase(
                        dataTitle = dataTitle,
                        dataValue = dataValue,
                        productId = id,
                    )
                },
                onSuccess = { result ->
                    when(dataTitle) {
                        ApiUtils.Field.price -> {
                            _state.value = _state.value.copy(
                                selectedProduct = state.value.selectedProduct
                                    ?.copy(price = dataValue)
                            )
                        }
                        ApiUtils.Field.priceInCafe -> {
                            _state.value = _state.value.copy(
                                selectedProduct = state.value.selectedProduct
                                    ?.copy(priceInCafe = dataValue)
                            )
                        }
                    }
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun updateProductProperties(
        id: String,
        minOrder: Double?,
        maxOrder: Double?,
        timeLeadDays: Double?,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(generalDataLoading = isLoading)
                },
                callRequest = {
                    updateProductPropertiesUseCase(
                        productId = id,
                        minOrder = minOrder,
                        maxOrder = maxOrder,
                        timeLeadDays = timeLeadDays
                    )
                },
                onSuccess = { result ->
                    val properties = result.data.cashAssist.updateProductProperties.properties
                     _state.value = _state.value.copy(
                        properties = Properties(
                            clickCollectLeadDaysCount = properties.clickCollectLeadDaysCount,
                            clickCollectOrderMax = properties.clickCollectOrderMax,
                            clickCollectOrderMin = properties.clickCollectOrderMin,
                        )
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun onProductClick(
        productId: String,
        switchTheSecondPage: () -> Unit = {},
    ) {
        if (productId != state.value.selectedProduct?.id) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(
                            generalDataLoading = isLoading
                        )
                    },
                    callRequest = {
                        singleProductUseCase(id = productId)
                    },
                    onSuccess = { result ->
                        val productData = result.data?.cashAssist?.getProduct
                        _state.value = _state.value.copy(
                            selectedProduct = productData,
                            properties = productData?.properties,
                            selectedSaleGroupId = productData?.salesGroupId,
                            selectedVat = productData?.codeMWSt,
                            selectedVat2 = productData?.codeMWSt2,
                            imageAiGeneratorDescription = productData?.name ?: "",
                            alternativeArticleName = productData?.altName ?: "",
                            specialPrices=productData?.specialPrices,
                            selectedPrice = null,
                            selectedProductSet = null,
                            selectedFixedProductSet=null,
                        )

                        tempPrices=productData?.specialPrices?: listOf()

                        getTemplateCategoryList()
                        getUnitSells()
                        getProductSet(id = state.value.selectedProduct?.id?:"")
                        switchTheSecondPage()
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        } else {
            switchTheSecondPage()
        }
    }


    private fun updateProductInCache(
        productId: String,
        updatedProduct: UpdateProduct?,
        refreshProductInfoState:Boolean=false,

    ) {
        getCachedProductCategoriesUseCase { cachedProducts ->

            if (cachedProducts == null) return@getCachedProductCategoriesUseCase

            val productExists = cachedProducts.any { it.id == productId }

            if (productExists) {
                val updatedProducts = cachedProducts.map { product ->
                    if (product.id == productId) {
                        product.copy(
                            code = updatedProduct?.code ?: product.code,
                            isActive = updatedProduct?.isActive ?: product.isActive,
                            name = updatedProduct?.name ?: product.name,
                        )
                    } else product
                }

                saveCachedProductCategoriesUseCase(updatedProducts)
                if (refreshProductInfoState){
                    TODO()
//                    _state.value=_state.value.copy(
//                        productsInfo = updatedProducts.filter {
//                            it.isActive==state.value.selectedProductFilterItemsType.value
//                        }
//                    )
                }

            }
        }
    }


    private fun getTemplateCategoryList() {
        launch {
            requestHandler(
                callRequest = {
                    getTemplateCategoriesUseCase()
                },
                onSuccess = { result ->
                    val sortedCategories = result.data?.cashAssist
                        ?.listCategories?.items?.sortedBy { it.position } ?: listOf()

                    _state.value = _state.value.copy(templateCategoryList = sortedCategories)
                }
            )
        }
    }
    private fun onTabClick(selectedTab: ProductInfoHeaderEnum) {
        _state.value = _state.value.copy(
            selectedTab = selectedTab,
        )
    }

    private fun showRequestError(result:List<GeneralError?>?) {
        _state.value = _state.value.copy(
            errorInfo =errorMessage(result)
        )
    }
    private fun showException(e: Exception) {
        if (!e.toString().contains(ApiUtils.Status.ERR_401)){
            _state.value = _state.value.copy(
                errorInfo = e.message.toString()
            )
        }
    }



}
